
export const RevenueReconciliationReportConstant = {
    Table: {
        REPORT_TYPE: "Report Type",
        PRINTER: "Printer",
        CUT_OFF_DATE_FROM: "Cut Off Date (From)",
        CUT_0FF_DATE_TO: "Cut Off Date (To)",
        CUT_OFF_DATE_2ND_FROM: "2ND Cut Off Date (From)",
        CUT_0FF_DATE_2ND_TO: "2ND Cut Off Date (To)",
        CURRRENCY: "Currency",
        CASHIER_ID: "Cashier Id",
        OPS_DATE_FROM: "Ops Date (From)",
        OPS_DATE_TO: "Ops Date (To)",
        DOC_DATE: "Doc Date",
        SUB_TYPE: "Sub Type",
    },
    Title: {
        TITLE: "Revenue And Reconciliation",
    },
}
